import { WebGPUFrameParser } from "./webgpuFrameParser"
import { FrameParser } from "./types"
let parser: FrameParser | Promise<FrameParser> | undefined = undefined
export const getFrameParser = async () => {
    if (parser instanceof Promise) return parser
    else if (!parser) {
        parser = new Promise(async (resolve) => {
            // for ssr
            if (typeof window === "undefined") resolve({} as unknown as FrameParser)
            const canvas = new OffscreenCanvas(1, 1)
            if (parser) resolve(parser)
            const p = new WebGPUFrameParser(canvas)
            await p.init?.()
            resolve(p)
        })
        return parser
    } else return Promise.resolve(parser)
}
